export const PROVIDERS = [
	'google' as const,
	'facebook' as const,
	'github' as const,
	'linkedin' as const,
	'email' as const,
	'google-id-token' as const,
	'apple' as const,
]
